import React, { useEffect, useRef, useCallback } from "react";
import { SFStack } from "../grid";
import SFSpinner from "../spinner";
import useStyled from "../../hooks/useStyled";
import SFLoadingRenderer from "./renderers/loadingRenderer";

const { styled } = useStyled();

const RowsGridContainer = styled(SFStack)(({ theme }) => ({
  paddingBottom: theme.spacing(2.5),
  height: 0,
  alignItems: "stretch",
}));

const LoaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  paddingBottom: theme.spacing(1),
}));

const RowContainer = ({ triggerLoad, row, data, loadingMessage }) => {
  const loaderRef = useRef();

  const handleObserver = useCallback(
    (entries) => {
      // Gets first element that is observed
      const target = entries[0];
      if (
        // Checks if element is in viewport
        target.isIntersecting
      ) {
        // Scrolls grid to last index
        triggerLoad(data?.rows?.length);
      }
    },
    [data]
  );

  useEffect(() => {
    const option = {
      // Makes intersection viewport bigger
      rootMargin: "20px",
    };

    const observer = new IntersectionObserver(handleObserver, option);
    if (loaderRef.current) {
      const element = loaderRef.current;
      observer.observe(element);
      return () => {
        observer.unobserve(element);
      };
    }
  }, [handleObserver, loaderRef]);

  return (
    <RowsGridContainer spacing={2}>
      {!data ? (
        <SFLoadingRenderer loadingMessage={loadingMessage} />
      ) : (
        <React.Fragment>
          {data?.rows.map((i, index) => (
            <React.Fragment key={index}>{row(i)}</React.Fragment>
          ))}
          <LoaderContainer ref={loaderRef}>
            {data.rows.length < data.rowCount && <SFSpinner size="large" />}
          </LoaderContainer>
        </React.Fragment>
      )}
    </RowsGridContainer>
  );
};

export default RowContainer;
